import { useGetStoredSelectedCategories, useGetStoredSelectedClients, useGetStoredSelectedContracts, useGetStoredSelectedVehicles, setSelectedRegional, setSelectedCategories, setSelectedClients, setSelectedContracts, setSelectedVehicles, useGetStoredSelectedRegional } from "@store/volksCustomAssetTree/volksCustomAssetTreeSlice";
import { useEffect, useState } from "react";
import dashboardService from "../../services/dashboard";
import { SidebarTree, SidebarTreeResponse } from "src-volkstotal/types/dashboard";

export const parseAssetNodeId = (id: string) => {
  const parts = id.includes('::') ? id.split('::') : id.split('-');
  return {
    type: parts[0] || '',
    regionalId: parts[1] || '',
    clientId: parts[2] || '',
    contract: parts[3] || '',
    vehicleId: parts[4] || '',
  };
};

export const useAssetTree = () => {
  const selectedRegional = useGetStoredSelectedRegional();
  const selectedCategories = useGetStoredSelectedCategories();
  const selectedClients = useGetStoredSelectedClients();
  const selectedContracts = useGetStoredSelectedContracts();
  const selectedVehicles = useGetStoredSelectedVehicles();
  const [loading, setLoading] = useState(false);

  const [assetData, setAssetData] = useState<SidebarTree | null>(null);

  const normalizeAssetTree = (response: SidebarTreeResponse): SidebarTree => {
    return {
      regionals: response.data.regionals.map((regional) => {
        const regionalId = regional.id || 0;

        return {
          id: `regional::${regionalId}`,
          name: regional.name,
          clients: regional.clients.map((client) => {
            const clientId = client.id || 0;

            return {
              id: `client::${regionalId}::${clientId}`,
              name: client.name,
              contracts: client.contracts.map((contract) => {
                const contractId = contract.code || '';

                return {
                  id: `contract::${regionalId}::${clientId}::${contractId}`,
                  name: contract.code,
                  vehicles: contract.vehicles.map((vehicle) => {
                    const vehicleId = vehicle.id || 0;

                    return {
                      id: `vehicle::${regionalId}::${clientId}::${contractId}::${vehicleId}`,
                      name: vehicle.name,
                      licensePlate: vehicle.licensePlate,
                    };
                  }),
                };
              }),
            };
          }),
        };
      }),
    };
  };

  useEffect(() => {
    const timeout = setTimeout(async () => {
      try {
        setLoading(true)
        const data = await dashboardService.getAssetTree();
        setAssetData(normalizeAssetTree(data));
      } catch (error) {
        console.error("Error fetching asset tree data:", error);
      }finally {
        setLoading(false)
      }
    }, 500)

    return () => clearTimeout(timeout);
  }, []);

  return {
    selectedRegional,
    selectedCategories,
    selectedClients,
    selectedContracts,
    selectedVehicles,
    setSelectedRegional,
    setSelectedCategories,
    setSelectedClients,
    setSelectedContracts,
    setSelectedVehicles,
    assetData,
    loading,
  }
}


export default useAssetTree;
